export default {
  hereApiKey: 'Uj54H8v7e_cVJQEsrmf27P_wAE7SuZlFKJoJa8nUnCc'
}



// WEBPACK FOOTER //
// ./src/components/routing/routingConfig.js